import { Star } from "lucide-react";

export default function StarRating({ value = 0, count, size = "sm" }) {
  const rounded = Math.round(value * 2) / 2;
  const sz = size === "lg" ? "h-5 w-5" : size === "md" ? "h-4 w-4" : "h-3.5 w-3.5";
  return (
    <div className="inline-flex items-center gap-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = rounded >= n;
        const half = !filled && rounded >= n - 0.5;
        return (
          <Star
            key={n}
            className={`${sz} ${filled || half ? "text-[#FFEA00] fill-[#FFEA00]" : "text-zinc-600"}`}
            strokeWidth={1.5}
          />
        );
      })}
      <span className="text-sm text-zinc-300 ml-1 font-semibold">
        {value ? value.toFixed(1) : "—"}
      </span>
      {count != null && (
        <span className="text-xs text-zinc-500 ml-1">({count})</span>
      )}
    </div>
  );
}
